import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';
// 客户开票回款-分页查询 - rzq
export const getCustomerInvoicePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/query/page',
        method: 'post',
        data
    });
};

// 客户开票回款-汇总 - rzq
export const getCustomerSum = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/sum',
        method: 'post',
        data
    });
};
// 客户开票回款-导入 - rzq
export const getCustomerImport = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/import',
        method: 'post',
        data
    });
};
// 客户开票回款-导出 - rzq
export const getCustomerExprot = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/export',
        method: 'post',
        data
    });
};
// 客户开票回款-更新 - rzq
export const updateInvoice = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/update',
        method: 'post',
        data
    });
};
// 客户开票回款-锁定 - rzq
export const lockInvoiceCustomer = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/lock',
        method: 'post',
        data
    });
};
// 模板下载-rzq
export const invoiceTemplateDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/invoice/template',
        method: 'post',
        data
    });
};
